// All storage keys MUST be the SAME as in livedata-data-cards-web-components-app/src/utils/storage.ts
export const localStorageMatchFollowKey = 'match-follow';
export const localStorageMatchIdKey = 'matchFollowId';
export const localStoragePositionKey = 'matchFollowPosition';
export const localStorageExpiresAtKey = 'matchFollowExpiresAt';
export const localStorageUpdatesKey = 'matchFollowUpdates';
export const localStorageModalIdKey = 'matchFollowIdModal';

export const LABEL_MATCH_FOLLOW = 'Segui la partita';
export const LABEL_MATCH_UNFOLLOW = 'Smetti di seguire';

const parseJSON = (json: string): object => {
  try {
    const parsed = JSON.parse(json);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch (e) {
    return {};
  }
};

const getValueJSON = (json: { [key: string]: any }, key: string): any => json[key];

const setValueJSON = (json: { [key: string]: any }, key: string, value: any): void => (json[key] = value);

const removeKeyJSON = (json: { [key: string]: any }, key: string): { [key: string]: any } => {
  delete json[key];
  return json;
};

export const storageGetValue = (storageKey: string, key: string): any => {
  const json = parseJSON(localStorage.getItem(storageKey) ?? '{}');
  return json ? getValueJSON(json, key) : null;
};

export const storageSetValue = (storageKey: string, key: string, value: any): void => {
  const json = parseJSON(localStorage.getItem(storageKey) ?? '{}');
  setValueJSON(json, key, value);
  localStorage.setItem(storageKey, JSON.stringify(json));
};

export const storageRemoveKey = (storageKey: string, key: string): void => {
  const json = parseJSON(localStorage.getItem(storageKey) ?? '{}');
  removeKeyJSON(json, key);
  localStorage.setItem(storageKey, JSON.stringify(json));
};
